import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';
import { ManagementQueryBlModel, ManagementQueryBlSearchModel } from '@data-layer/models/management';
import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class QueryBlManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: PaginationSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementQueryBlSearchModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementQueryBlSearchModel>>(
      `${environment.url.prefixCustoms}management/bill-queries`,
      { params },
      { isShowLoader },
    );
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementQueryBlSearchModel> {
    return this.apiService.get<ManagementQueryBlSearchModel>(`${environment.url.prefixCustoms}management/bill-queries/${id}`, null, {
      isShowLoader,
    });
  }

  public create(model: ManagementQueryBlModel, isShowLoader: boolean = true): Observable<ManagementQueryBlSearchModel> {
    return this.apiService.post<ManagementQueryBlSearchModel>(`${environment.url.prefixCustoms}management/bill-queries`, model, null, {
      isShowLoader,
    });
  }
}
